<template>
    <AppHeaderDropdown right no-caret show>
        <template slot="header">
            <b-nav-item class="d-md-down-none">
                <i class="icon-grid" style="color: #fff;"></i>
            </b-nav-item>
        </template>
        <template slot="dropdown">
            <b-dropdown-item disabled ><i class="fa fa-tree"/>Baumkontrolle</b-dropdown-item>
          <b-dropdown-item   v-on:click="triggerPersonalwesen" v-if="hasModule(13)"><i class="fa fa-calendar" style="color: black"/> Personalwesen</b-dropdown-item>
          <b-dropdown-item   v-on:click="triggerPersonalwesen" v-if="hasModule(14) && !hasModule(13)"><i class="fa fa-calendar" style="color: black"/> Rufbereitschaft</b-dropdown-item>
          <b-dropdown-item   v-on:click="triggerMobileSettings" v-if="hasModule(12)"><i class="fa fa-mobile-phone" style="color: black"/>Einstellungen Mobile Geräte</b-dropdown-item>
            <b-dropdown-item   v-on:click="triggerAuftragsbuch" v-if="hasModule(4)"><i class="fa fa-briefcase" style="color: black"/> Auftragsbuch</b-dropdown-item>
            <b-dropdown-item v-on:click="triggerNutzerverwaltung" v-if="hasModule(6)"><i class="fa fa-users" style="color: black"/>Nutzerverwaltung</b-dropdown-item>
            <b-dropdown-item v-on:click="triggerAdmin" v-if="isAdmin && false"><i class="fa fa-wrench" style="color: black"/>Administration</b-dropdown-item>
        </template>
    </AppHeaderDropdown>
</template>

<script>
    import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
    export default {
        name: 'ChangeModuleDropdown',
        components: {
            AppHeaderDropdown
        },
        props:{
            isAdmin: {
                type: Boolean,
                default: () => false
            },
            modules: {
                type: Array,
                default: () => []
            },

        },
        methods: {
            hasModule(module) {
                for (let i = 0; i < this.modules.length; i++) {
                    if (this.modules[i] === module) {
                        return true;
                    }
                }
                return false
            },
            triggerAdmin() {
                this.$emit('admin');
            },
            triggerAuftragsbuch() {
                this.$emit('auftragsbuch');
            },
            triggerNutzerverwaltung() {
                this.$emit('nutzerverwaltung');
            },
            triggerMobileSettings() {
                this.$emit('mobileSettings');
            },
          triggerPersonalwesen() {
            this.$emit('zk');
          },
        }
    }
</script>
